import { createSelector } from 'reselect';
import cloneDeep from 'lodash/cloneDeep';
import { campaignState, quoteState } from '../selectors';

export const makeCampaignRows = (campaignLines, bookingCampaign) =>
  cloneDeep(campaignLines).map((campaign) => {
    const { operationId, discount, coupon, title, type } = campaign;
    const row = {
      // ...campaign,
      workSummary: `${type === 'discount' ? 'Discount' : 'Coupon'}: ${title}`,
      fixedCostWithVAT: discount ? `${discount * -100}%` : coupon / 100,
      key: `discount-row-${operationId}`,
      type,
      discount,
      coupon,
      className: ['discount-row', 'footer-row'],
      editable: false,
      appliedToCheckout: bookingCampaign?.appliedToCheckout,
      appliedToEWO: bookingCampaign?.appliedToEWO,
    };
    return row;
  });

export default function campaignSelector() {
  return createSelector(quoteState, campaignState, (quote, campaign) => {
    if (!quote) return [];
    const campaignLines = quote
      .get('lineItems')
      .filter((li) => ['coupon', 'discount'].includes(li.get('type')))
      .toJS();
    if (!campaign) {
      // Bundle discounts are virtual line items, not campaigns, so they are not
      // covered by a booking campaign record. Show them like the MOT bundle.
      return makeCampaignRows(
        campaignLines.filter((li) => ['MOT-BUNDLE', 'REPAIR-UPSELL'].includes(li.source)),
        null
      );
    }
    return makeCampaignRows(
      campaignLines,
      campaign.toJS()
    );
  });
}
